import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as THREE from 'three';
import computeBuffers from "./Prefab/computeBufferTileGeometry";
function defaultBuffers(params) {
  params.buildIndexAndUv_0 = true;
  params.center = params.builder.center(params.extent).clone();
  var buffers = computeBuffers(params);
  buffers.index = new THREE.BufferAttribute(buffers.index, 1);
  buffers.uvs[0] = new THREE.BufferAttribute(buffers.uvs[0], 2);
  buffers.position = new THREE.BufferAttribute(buffers.position, 3);
  buffers.normal = new THREE.BufferAttribute(buffers.normal, 3);
  for (var i = 1; i < params.builder.uvCount; i++) {
    buffers.uvs[1] = new THREE.BufferAttribute(buffers.uvs[1], 1);
  }
  return buffers;
}
var TileGeometry = /*#__PURE__*/function (_THREE$BufferGeometry) {
  _inherits(TileGeometry, _THREE$BufferGeometry);
  var _super = _createSuper(TileGeometry);
  function TileGeometry(params) {
    var _this;
    var buffers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultBuffers(params);
    _classCallCheck(this, TileGeometry);
    _this = _super.call(this);
    _this.center = params.center;
    _this.extent = params.extent;
    _this.setIndex(buffers.index);
    _this.setAttribute('position', buffers.position);
    _this.setAttribute('normal', buffers.normal);
    for (var i = 0; i < buffers.uvs.length; i++) {
      _this.setAttribute("uv_".concat(i), buffers.uvs[i]);
    }
    _this.computeBoundingBox();
    _this.OBB = {};
    return _this;
  }
  return _createClass(TileGeometry);
}(THREE.BufferGeometry);
export default TileGeometry;